// @mui
import { SvgIcon } from "@mui/material";

function ArrowLeftIcon(props) {
  return (
    <SvgIcon
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      sx={{
        fill: "none",
        "& g": {
          stroke: (theme) => theme.palette.text.primary,
        },
      }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Iconly/Light/Arrow---Left"
        stroke={props.color || "#1B1B1D"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Arrow---Left"
          transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) translate(5.500000, 4.000000)"
          stroke={props.color || "#1B1B1D"}
          strokeWidth="1.5"
        >
          <line x1="6.7743" y1="15.75" x2="6.7743" y2="0.75" id="Stroke-1"></line>
          <polyline id="Stroke-3" points="12.7987 9.7002 6.7747 15.7502 0.7497 9.7002"></polyline>
        </g>
      </g>
    </SvgIcon>
  );
}

export default ArrowLeftIcon;
